<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <autogestion-log-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('AUTOGESTIONLOG_CREATE')" @click="create"></add-button>
      
        <autogestion-log-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <autogestion-log-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <autogestion-log-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <autogestion-log-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import AutogestionLogCreate from "./AutogestionLogCreate";
    import AutogestionLogUpdate from "./AutogestionLogUpdate";
    import AutogestionLogDelete from "./AutogestionLogDelete";
    import AutogestionLogShow from "./AutogestionLogShow";
    import AutogestionLogList from "./AutogestionLogList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "AutogestionLogCrudPage",
        components: {
            CrudLayout, AddButton, Snackbar,
            AutogestionLogCreate, 
            AutogestionLogUpdate, 
            AutogestionLogDelete, 
            AutogestionLogShow,
            AutogestionLogList
        },
        data() {
            return {
                title: 'cobrox.autogestionLog.title',
                subtitle: 'cobrox.autogestionLog.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


